import { data } from 'jquery';
import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class ReleaseIncidentAPI {
  static getFilterData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetReleaseIncidentFilterData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data  //undo this and use method callAzureFunction while checking in
    );
  }

  static GetIncidentByEvent(eventid) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetIncidentByEvent.replace("{eventid}", eventid),
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      {}
    );
  }
  
  static getScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetReleaseIncidentData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,   //undo this and use method callAzureFunction while checking in
      data
    );
  }
  
  static updateVendorScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateVendorData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static uploadIncidentFiles(data) {
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.UploadReleaseIncidentFile,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }

  static saveLeakDetectionResponseForm(data){
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.SaveLeakDetectionResponseForm,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }

  static LeakDetectionStatusUpdate(data){
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.LeakDetectionStatusUpdate,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }

  static sendMailApi(data){
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.sendMailApi,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }

  static UpdateApprovedByReleaseIncident(data){
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.UpdateApprovedByReleaseIncident,
      'PUT',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }

  static GetApproversReleaseIncident(){
    return RestEndPoint.callAzureFunctionPostFile(
      APIUrlConstants.GetApproversReleaseIncident,
      'GET',
      AppConstants.APP_BACKEND_HOST_KEY,
    );
  }

  static releaseIncidentDownload(id,data){
    return RestEndPoint.lealDetectionDownload(
      APIUrlConstants.DownloadReleaseIncidenFile,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      {'incident':id,'fileName':data});
  }

  static releaseIncidentExcelDownload(data){
    return RestEndPoint.lealDetectionDownload(
      APIUrlConstants.ExportResponseForm,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data);
  }


  static getIncidentFiles(data) {
    return RestEndPoint.callAzureFunction(
      `${APIUrlConstants.GetReleaseIncidentFiles}?incident=${data}`,
      'GET',
      AppConstants.APP_BACKEND_HOST_KEY
      );
    
  }
  static getLeakDetections(eventNumber) {
    // return RestEndPoint.callAzureFunction(
    //   `${APIUrlConstants.GetLeakDetections}`,
    //   'POST',
    //   AppConstants.APP_BACKEND_HOST_KEY,
    //   eventNumber
    //   );
    // }
  
    
      return RestEndPoint.callAzureFunction(
      `${APIUrlConstants.GetLeakDetections+'?EventId='+eventNumber.EventNumber}`,
      'GET',
      AppConstants.APP_BACKEND_HOST_KEY,
      eventNumber
      );
    }
    

}
